import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        //await this.GetAllAcademicLevels()

        this.GetInfo(this.pageNo);
        await this.loadChildren(null, 0); 
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: ' التخصصات الدراسية   ',
            ScreenTitleSingle: ' تخصص دراسي ',
            ScreenTitleSingleAl: 'التخصص الدراسي ',

            Info: [],
            Statistics: [],
            selectedPath: [],
            selects: [], 

            AddDialog: false,

            SelectedItem:'',

            ruleForm: {
                Id: '',
                ParentId: '',
                Name: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
                Levels: '',
            },
            rules: {
                ParentId: this.$helper.Required(),
                Name: this.$helper.Required(),
            },
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetAcademicSpecializationsChild(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    const data = (response && response.data) || {};
                    this.Info = data.info || [];
                    this.pages = data.count || 0;
                    this.Statistics = data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = {};
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    this.ruleForm.Levels = Number(0);
                    this.$blockUI.Start();
                    this.$http.AddAcademicSpecializations(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.ParentId = item.parentId;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions;
            this.fillEditSpecializations(item.parentId);
            
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.ruleForm.Id);
                    this.ruleForm.Levels = Number(0);
                    this.$blockUI.Start();
                    this.$http.EditAcademicSpecializations(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusAcademicSpecializations(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteAcademicSpecializations(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },


        //loop tere
        async loadChildren(parentId) {
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetAllAcademicSpecializations(parentId);

                this.selects.push({
                    options: (res && res.data && res.data.info) || [],
                    selected: null
                });

            } catch (e) {
                this.selects.push({
                    options: [],
                    selected: null
                });
            } finally {
                this.$blockUI.Stop();
            }
        },



        onSelectChange(index, selectedId) {

            // 1️⃣ remove ALL selects after the changed one
            this.selects = this.selects.slice(0, index + 1);

            // 2️⃣ update selected value
            this.selects[index].selected = selectedId;

            // 3️⃣ find selected item
            const selectedItem = this.selects[index].options.find(
                x => x.id === selectedId
            );

            if (!selectedItem) {
                this.ruleForm.ParentId = null;
                return;
            }

            // 4️⃣ save last selected ID only
            this.ruleForm.ParentId = selectedItem.id;

            // 5️⃣ load children ONLY if exist
            if (selectedItem.hasChildren) {
                this.loadChildren(selectedItem.id, index + 1);
            }
        },




        //For Update 
        async fillEditSpecializations(parentId) {

            // reset everything
            this.selects = [];
            this.ruleForm.ParentId = null;

            this.$blockUI.Start();

            try {
                // 1️⃣ get full path
                const pathRes = await this.$http.GetAcademicSpecializationPath(parentId);
                const path = pathRes.data; // [{id,name}]

                // 2️⃣ load root first
                await this.loadChildren(null, 0);

                // 3️⃣ walk through path
                for (let i = 0; i < path.length; i++) {

                    const currentId = path[i].id;

                    // set selected
                    this.selects[i].selected = currentId;
                    this.ruleForm.ParentId = currentId;

                    // load next level if exists
                    if (i < path.length - 1) {
                        await this.loadChildren(currentId, i + 1);
                    }
                }

            } finally {
                this.$blockUI.Stop();
            }
        }

    }
}
